<template>
  <div class="work-flow-type-text">
    <span v-if="type === 'text'">{{ text }}</span>
    <el-select v-else :value="value" @input="onInput" :disabled="disabled">
      <el-option
        v-for="(item, index) in list"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>/firmwareTask/edit

<script>
/** 工作流类型需要调用接口获取转化 */
import apis from '@/utils/apis';

export default {
  props: {
    // select 时传
    workflowClass: [Number, String],
    workflowId: [Number, String],
    // text 时传
    workflowType: [Number, String],
    // text select
    type: {
      type: String,
      default: 'text'
    },
    value: [Number, String],
    disabled: Boolean
  },
  data() {
    return {
      list: []
    };
  },
  computed: {
    text() {
      return this.getDicValue('approval_type', this.workflowType);
    }
  },
  watch: {
    workflowClass: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true
    }
  },
  methods: {
    getList() {
      this.$getJSON(
        `${apis.workflowInfoApproveType}/${this.workflowClass}`, {
          workflowId: this.workflowId ? this.workflowId : undefined
        }
      ).then((res) => {
        this.list = res.data.filter(item => item);
      });
    },
    onInput(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style></style>
